import loadMujoco, { type MainModule } from "@mujoco/mujoco";

let modulePromise: Promise<MainModule> | null = null;
let moduleOptions: Record<string, unknown> | undefined;

/**
 * Emscripten module options for the one load that will happen. The study never calls this;
 * the offline demo passes `wasmBinary` so the runtime is instantiated from bytes already in
 * the page, because a page opened from `file://` may not fetch anything.
 */
export function configureMujoco(options: Record<string, unknown>): void {
  if (modulePromise) throw new Error("MuJoCo is already loading; configure it first");
  moduleOptions = options;
}

export function getMujoco(): Promise<MainModule> {
  modulePromise ??= loadMujoco(moduleOptions);
  return modulePromise;
}
